import React from "react"
import classNames from "classnames";
import PropTypes from "prop-types";
import { buttonLinkPropTypes } from "@/utils/types";
import CustomLink from "./custom-link";
import LinkChevron from '../../images/link-chevron.svg';
import ArrowBackWhite from '../../images/arrow-back-white.svg';
import emojione from 'emojione';

const ButtonContent = ({ button, appearance, compact }) => {
  const textEmojified = emojione.shortnameToUnicode(button.text);

  return (
    <div
      className={classNames(
        // Common classes
        "button-link",
        // Full-size button
        {
          "px-4 py-3": compact === false,
        },
        // Compact button
        {
          "px-6 py-2": compact === true,
        },
        // Specific to when the button is fully dark
        {
          "button-link--primary": appearance === "primary",
        },
        // Specific to when the button is dark outlines
        {
          "button-link--secondary": appearance === "secondary",
        },
        {
          "button-link--tertiary": appearance === "tertiary",
        },
        { 
          "button-link--primaryback": appearance === "primaryback",
        }
      )}
    >
      {button.icon === "false" ? <>{textEmojified}</> : button.type === "primaryback" ? <><ArrowBackWhite className="icon"/> {textEmojified}</> : <>{textEmojified} <LinkChevron className="icon"/></> }
      { }
    </div>
  );
};

const ButtonLink = ({ button, appearance, compact = false }) => {
  return (
    <CustomLink link={button}>
      <ButtonContent button={button} appearance={appearance} compact={compact} />
    </CustomLink>
  );
};

ButtonLink.propTypes = {
  button: buttonLinkPropTypes,
  appearance: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "primaryback",
  ]),
  compact: PropTypes.bool
};

export default ButtonLink;
